import React, { Fragment } from 'react';
import pt from 'prop-types';
import cx from 'classnames';

import Overlay from 'components/overlay';
import StorefrontEditorIcon from 'components/storefront/editor/icon';

const ITEMS = Object.freeze([
  [{ id: 'duplicate', icon: 'copy', label: 'Duplicate' }],
  [{ id: 'delete', icon: 'trash', label: 'Delete page', className: 'danger' }],
]);

export default class PageEllipsisOverlay extends React.PureComponent {
  static propTypes = {
    data: pt.shape({
      domRect: pt.instanceOf(DOMRect).isRequired,
      page: pt.object.isRequired,
      overlayProps: pt.object,
    }),
    onDuplicatePage: pt.func.isRequired,
    onDeletePage: pt.func.isRequired,
    onClose: pt.func.isRequired,
  };

  static contextTypes = {
    openModal: pt.func.isRequired,
    closeModal: pt.func.isRequired,
  };

  async duplicate() {
    const { openModal } = this.context;
    const { data, onDuplicatePage, onClose } = this.props;
    const { page } = data;

    onClose();
    openModal('Confirm', {
      loading: true,
      loadingTitle: 'Duplicating page',
    });

    await onDuplicatePage(page);

    closeModal();
  }

  delete() {
    const { openModal } = this.context;
    const { data, onDeletePage, onClose } = this.props;
    const { page } = data;

    openModal('ConfirmDelete', {
      title: page.label,
      titleMessage: 'Delete page',
      onConfirm: async () => {
        await onDeletePage(page.id);
        onClose();
      },
      onCancel: onClose,
    });
  }

  onClick = (event) => {
    event.preventDefault();

    const { id } = event.currentTarget.dataset;

    switch (id) {
      case 'duplicate':
        return this.duplicate();
      case 'delete':
        return this.delete();
      default:
        return null;
    }
  };

  renderItem = (item) => {
    const { page } = this.props.data;
    const { id, icon, label, className } = item;
    const hasSpecificActions = page.actions?.length > 0;
    const isActionEnabled = !hasSpecificActions || page.actions.includes(id);

    if (!isActionEnabled) {
      return null;
    }

    return (
      <button
        className={cx('storefront-editor--overlay-item', className)}
        data-id={id}
        onClick={this.onClick}
      >
        <StorefrontEditorIcon type={icon} width={14} height={14} />
        {label}
      </button>
    );
  };

  renderItemGroup = (itemGroup, index) => {
    const items = itemGroup.map(this.renderItem).filter(Boolean);
    const hasItems = items.length > 0;

    if (!hasItems) {
      return null;
    }

    return (
      <Fragment key={index}>
        {index !== 0 && <hr />}
        <div className="storefront-editor--overlay-item-group">{items}</div>
      </Fragment>
    );
  };

  render() {
    const { data, onClose } = this.props;

    return (
      <Overlay
        className="storefront-editor--overlay storefront-editor--overlay-ellipsis"
        domRect={data.domRect}
        items={ITEMS}
        renderItem={this.renderItemGroup}
        onClose={onClose}
        search={false}
        {...data.overlayProps}
      />
    );
  }
}
